import React from 'react'

import { StyledSwitch as S } from './Switch.styles'

type TSwitchTypes = {
  isChecked: boolean
  onChange: (event) => void
  value: string
}

export const Switch: React.FC<TSwitchTypes> = ({
  isChecked = false,
  onChange,
  value,
}) => (
  <S.Root>
    <S.Input
      value={value}
      checked={isChecked}
      onChange={onChange}
      type="checkbox"
    />
    <S.Button />
    <S.Track />
  </S.Root>
)
